import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerFonoaudiologia'; 
import AboutPsicopedagogia from './AboutFonoaudiologia';
import Psicopedagogia from './CorpoClinicoFonoaudiologia';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutPsicopedagogia />
        <Psicopedagogia />
      </div>
    );
  };
  
  export default About;
  